module.exports = __webpack_public_path__ + "8a9d0d60fa01cd9bf89427f7e151acdd.png";